import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@shared/lib/cn'
import { LocalizedLink as Link } from '@shared/lib/locale'
import Button from '@shared/ui/button'

import styles from './CookieConsent.module.scss'


const COOKIE_CONSENT_KEY = 'cookie_consent_accepted'

/**
 * Компонент баннера согласия на использование cookies
 * В соответствии с законодательством РФ (ФЗ-152) и Казахстана (Закон о персональных данных)
 */
export const CookieConsent = () => {
  const { t } = useTranslation('cookie-consent')
  const [ isVisible, setIsVisible ] = useState(false)

  useEffect(() => {
    // Проверяем, было ли уже получено согласие
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!consent) {
      // Небольшая задержка для плавного появления
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true')
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className={cn(styles.root, isVisible && styles.visible)}>
      <div className={styles.content}>
        <p className={styles.text}>
          {t('message')}{' '}
          <Link to="/media/category/legal/politika-v-otnoshenii-obrabotki-personal-nyh-dannyh" className={styles.link}>
            {t('privacy_policy')}
          </Link>
        </p>
        <Button
          onClick={handleAccept} 
          size="small"
          theme="primary"
          className={styles.button}
        >
          {t('accept')}
        </Button>
      </div>
    </div>
  )
}

export default CookieConsent
